<section>
  <mat-dialog-content class="mat-typography">
    <div class="d-flex align-items-center mb-3">
      <button mat-icon-button class="back_icon" (click)="closeDialog(false)">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h4 translate class="m-0">Add Banners</h4>
    </div>
    <mat-divider></mat-divider>

    <form [formGroup]="bannersForm" class="form-container">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <!-- Banner Title Input -->
            <app-question [question]="questions[0]" [form]="bannersForm"></app-question>

            <!-- Upload Box -->
            <div class="upload-container">
              <input #fileInput hidden type="file" (change)="imageInputChange($event)" />
              <div class="upload-box" (click)="fileInput.click()">
                <ng-container *ngIf="!selectedImageUrl">
                  <img src="../../../../../../assets/images/bulkupload_logo.svg" alt="Upload Banner"
                    class="upload-icon" />
                  <p translate class="image-dimensions-note">
                    *Recommended: 1920px (W) × 720px (H)
                  </p>
                </ng-container>

                <!-- Display Selected Image -->
                <ng-container *ngIf="selectedImageUrl">
                  <img [src]="selectedImageUrl" alt="Selected Image" class="uploaded-image" />
                </ng-container>
              </div>
            </div>

            <!-- Additional Inputs -->
            <div class="additional-fields">
              <app-question [question]="questions[1]" [form]="bannersForm"></app-question>
              <app-question [question]="questions[2]" [form]="bannersForm"></app-question>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <!-- Buttons Section -->
   <mat-dialog-actions align="end" class="w-100 bg-white position-absolute bottom-0 end-0">
    <button translate mat-stroked-button (click)="closeDialog(false)" class="cancel-btn cancel_button">
      Cancel
    </button>
    <button translate mat-raised-button color="primary" class="submit-btn" type="submit" [disabled]="!bannersForm.valid"
      (click)="onSubmit()">
      Submit
    </button>
  </mat-dialog-actions>
</section>